import { render } from "./LandingPageView.vue?vue&type=template&id=19daac21"
import script from "./LandingPageView.vue?vue&type=script&lang=js"
export * from "./LandingPageView.vue?vue&type=script&lang=js"

import "./LandingPageView.vue?vue&type=style&index=0&id=19daac21&lang=css"

import exportComponent from "/home/gustavo/Documents/frontend-ivv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__